export const types = {
    SET_MODAL_DATA: 'SET_MODAL_DATA',
    SET_MODE_DATA: 'SET_MODE_DATA',
    SET_ACCESS_DATA: 'SET_ACCESS_DATA',
    SET_ACCOUNT_MODAL_DATA: 'SET_ACCOUNT_MODAL_DATA',
    SET_WITHDRAW_MODAL_DATA: 'SET_WITHDRAW_MODAL_DATA',
    SET_DEPOSIT_MODAL_DATA: 'SET_DEPOSIT_MODAL_DATA'
};

export const server = {
    PATH: 'http://localhost:8888/',
}
